// removed by extract-text-webpack-plugin
module.exports = {"details-container":"_2s5XQnrzkf90YGV2VgrKAc","edit-header":"_3zxN5omS0E3WEnIxvDOu9M","member-info":"_16sW610b3_gFQUye6dcByq","spouse-info":"_2UalHQKjXWXdGkx1izuCZ9","action-button":"_2tqoQuyEvO4oLn3tymxLnU"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/EditMember/styles.css
// module id = 1523
// module chunks = 0